import { render, staticRenderFns } from "./activity.page.vue?vue&type=template&id=70747066&"
import script from "./activity.page.vue?vue&type=script&lang=ts&"
export * from "./activity.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports